module.exports = __webpack_public_path__ + "static/media/joinHands.d9a2b1bc.png";